import _                               from 'underscore';
import React, { ReactNode, useEffect } from 'react';
import { Cell, Grid }                  from "styled-css-grid";
import { StyledContainer }             from "@src/views/containers/StyledContainer";
import { Size }                        from "@src/types";
import { PolyRenderer }                from "@src/views/components/display/PolyRenderer";


interface MenuizedFocusContainerLayoutProps<T = never> {
    minContainerHeight?: string,
    minMenuWidth?: string,
    maxMenuWidth?: string,
    minOptionWidth?: string,
    maxOptionWidth?: string,
    menuContent: ReactNode,
    viewContent: ReactNode,
    optionsContent?: ReactNode | ( () => ReactNode )
}

const MenuizedFocusContainerLayoutDefaultProps = {
    minContainerHeight: '300px',
    minMenuWidth:       'auto',
    maxMenuWidth:       '210px',
    minOptionWidth:     'auto',
    maxOptionWidth:     '210px'
} satisfies Partial<MenuizedFocusContainerLayoutProps>

function MenuizedFocusContainerLayout<T>( _props: MenuizedFocusContainerLayoutProps<T> ){


    const props = { ...MenuizedFocusContainerLayoutDefaultProps, ..._props };

    const hasOptionsContent = !( _.isNull( props.optionsContent ) || _.isUndefined( props.optionsContent ) ),
          minOptionWidth    = props.minOptionWidth ?? MenuizedFocusContainerLayoutDefaultProps.minOptionWidth,
          maxOptionWidth    = props.maxOptionWidth ?? MenuizedFocusContainerLayoutDefaultProps.maxOptionWidth;

    return (
        <Grid columns={ `minmax(${ props.minMenuWidth }, ${ props.maxMenuWidth }) 1fr` }
              columnGap={ `0px` }
              style={ { width: `100%`, height: '100%' } }
              areas={ [ 'view-menu view-focus' ] }>

            {/* View Menu */ }
            <Cell area={ 'view-menu' }>

                <StyledContainer padding={ [ Size.MD, null ] }>

                    { props.menuContent }

                </StyledContainer>

            </Cell>

            {/* Current View */ }
            <Cell area={ 'view-focus' }>

                <StyledContainer padding={ Size.MD } style={ { height: '100%' } }>

                    <Grid
                        columns={
                            `1fr ${ hasOptionsContent
                                    ? `minmax(${ minOptionWidth }, ${ maxOptionWidth })`
                                    : 'auto' }`
                        }
                        columnGap={ hasOptionsContent ? `30px` : '0px' }
                        rows={ `minmax(${ props.minContainerHeight }, 1fr)` }
                        style={ { width: `100%`, height: '100%' } }
                        areas={ [ 'view view-options' ] }
                        className={ 'position--relative' }>

                        {/* Focused View Area */ }
                        <Cell area={ 'view' } className={ 'position--relative' }>

                            { props.viewContent }

                        </Cell>

                        {/* Focused View Options */ }
                        <Cell area={ 'view-options' } className={ 'position--relative' }>

                            <PolyRenderer value={ props.optionsContent } fallback={ props.optionsContent }/>

                        </Cell>

                    </Grid>

                </StyledContainer>

            </Cell>

        </Grid>
    );
}

export {
    MenuizedFocusContainerLayout,
    MenuizedFocusContainerLayoutDefaultProps,
    type MenuizedFocusContainerLayoutProps,
};
